import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { css, cx } from "../../styled-system/css";
import { Flex } from "../../styled-system/jsx";
import logo from "../assets/images/logo/Trellis_Logo.png";
import { LanguageSwitcher } from "../i18n/LanguageSwitcher";

interface FormLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  maxWidth?: string;
}

export const AuthLayout = ({ title, subtitle, children, maxWidth = "400px" }: FormLayoutProps) => {
  const { t } = useTranslation("auth");
  return (
    <div
      className={css({
        width: "100vw",
        height: "100vh",
        backgroundColor: "transparent",
        backgroundImage: "linear-gradient(180deg, #ccccfb 0%, #fefbf8 100%)",
      })}
    >
      <div
        className={css({
          position: "absolute",
          top: "medium",
          right: "medium",
          zIndex: 1,
        })}
      >
        <LanguageSwitcher />
      </div>
      <Flex
        className={cx(
          css({
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            backgroundPosition: "98% 88%",
            backgroundImage:
              "url(https://cdn-fmiak.nitrocdn.com/YToHrQyfyldjDvtszlOhyMekSnKbbxeX/assets/images/optimized/rev-15a5c3a/gotrellis.com/wp-content/uploads/2022/09/Arrows-1.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "307px auto",
            transition: "filter 0.5s ease 0s",
            filter: "brightness(100%) contrast(100%) saturate(100%) blur(0px) hue-rotate(0deg)",
          }),
          "fs-standard",
        )}
      >
        <a href="https://gotrellis.com" target="_blank" rel="noopener noreferrer">
          <img
            src={logo}
            alt={t(($) => $.auth.layout["Trellis Logo"])}
            className={css({ height: "7rem", marginBottom: "3rem" })}
          />
        </a>
        <div
          className={css({
            borderRadius: "10px",
            width: "100%",
            maxWidth,
            padding: "large",
            backgroundColor: "white",
          })}
        >
          <h3 className={css({ marginBottom: "medium", fontSize: 25, fontWeight: "500", textAlign: "center" })}>
            {title}
          </h3>
          {subtitle && (
            <p className={cx("fs-standard", css({ marginBottom: "medium", textAlign: "center" }))}>{subtitle}</p>
          )}
          {children}
        </div>
      </Flex>
    </div>
  );
};
